const getBrowserScrollbarWidth = () => {
  if (typeof window === 'undefined') return undefined

  const cssVariable = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue('--scrollbar-width')

  if (cssVariable) return cssVariable

  const scrollDiv = document.createElement('div')
  scrollDiv.style.cssText =
    'width: 100px;height: 100px;overflow: scroll;position: absolute;top: -9999px;'
  document.body.appendChild(scrollDiv)
  const scrollbarWidth = `${scrollDiv.offsetWidth - scrollDiv.clientWidth}px`
  document.body.removeChild(scrollDiv)

  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth)
  return scrollbarWidth
}

const scrollLock = (lock: boolean): undefined => {
  if (!document || !document.body || !document.body.parentElement) return undefined

  // Only apply scroll lock on non-lg viewports (< 1024px)
  const isLgOrAbove = typeof window !== 'undefined' && window.innerWidth >= 1024

  if (isLgOrAbove) {
    // Clean up scroll lock on lg+ viewports
    document.body.parentElement.style.overflow = ''
    document.body.parentElement.style.paddingRight = ''
    document.body.classList.remove('u-lock')
    document.documentElement.classList.remove('u-scroll-locked')
    return undefined
  }

  document.body.parentElement.style.overflow = lock ? 'hidden' : ''
  document.body.parentElement.style.paddingRight = lock ? getBrowserScrollbarWidth() || '' : ''

  if (lock) {
    document.body.classList.add('u-lock')
    document.documentElement.classList.add('u-scroll-locked')
  } else {
    document.body.classList.remove('u-lock')
    document.documentElement.classList.remove('u-scroll-locked')
  }

  return undefined
}

export default scrollLock
export { getBrowserScrollbarWidth }
